// extracted by mini-css-extract-plugin
export default {"editButton":"addPayroll_editButton__2FGPr","TableBody":"addPayroll_TableBody__-Lh0S","deleteButton":"addPayroll_deleteButton__fSFss"};